import React, { useState, useEffect } from "react";
import ProgramsPage from "./components/ProgramsPage";
import AboutPage from "./components/AboutPage";
import HomePage from "./components/HomePage";
import Header from "./components/Header";
import GalleryPage from "./components/GalleryPage";
import ContactPage from "./components/ContactPage";
import Footer from "./components/Footer";

const FloatingBalloon = ({ delay, duration, startPosition }) => {
  return (
    <div
      className="fixed text-4xl pointer-events-none animate-float-up opacity-0"
      style={{
        bottom: "-100px",
        left: `${startPosition}%`,
        animationDelay: `${delay}s`,
        animationDuration: `${duration}s`,
      }}
    >
      🎈
    </div>
  );
};

export default function App() {
  const [currentPage, setCurrentPage] = useState("home");
  const [balloons, setBalloons] = useState([]);

  useEffect(() => {
    const newBalloons = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      delay: Math.random() * 15,
      duration: 15 + Math.random() * 10,
      startPosition: Math.random() * 100,
    }));
    setBalloons(newBalloons);
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case "home":
        return <HomePage />;
      case "about":
        return <AboutPage />;
      case "programs":
        return <ProgramsPage />;
      case "gallery":
        return <GalleryPage />;
      case "contact":
        return <ContactPage />;
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-pink-50">
      <div className="fixed inset-0 pointer-events-none z-10 overflow-hidden">
        {balloons.map((balloon) => (
          <FloatingBalloon key={balloon.id} {...balloon} />
        ))}
      </div>

      <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
      <main className="relative z-20">{renderPage()}</main>
      <Footer />
    </div>
  );
}
